import * as React from 'react'
import { navigate } from 'gatsby-link'
import { nomalizeUrl } from '../../util/shared'

export const withRedirect = url => {
  const Redirect = () => {
    React.useEffect(() => {
      navigate(nomalizeUrl(url))
    }, [])

    return (
      <div>Loading...</div>
    )
  }

  return Redirect
}

export const MiniappDevIndex = withRedirect('/miniapp/dev/guide')
export const MiniappPayIndex = withRedirect('/miniapp/pay/main')
export const DataSharingIndex = withRedirect('/data-sharing/data-game')
export const MiniappDevOpenIndex = withRedirect('/miniapp/dev/open/verify')
export const MiniappDanmuGameIndex = withRedirect('/miniapp/danmugame/intro')